module.exports = __webpack_public_path__ + "img/20.87d2e85f.jpg";